import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import { useUseTemplateUpdateProtocolQuery } from "./useTemplateUpdateProtocol.generated.js";

export const useTemplateUpdateProtocol = (templateId: string) => {
  const client = useApolloClient();
  const query = useUseTemplateUpdateProtocolQuery({
    client,
    variables: {
      templateId,
    },
  });
  return getDataOrNull(query.data?.quoteTemplates)?.edges[0]?.node;
};
